export const RECORD_STORY = 'record_story';
export const E2E_GREEN_TIP = 'e2e_feature_gate';

export const FEATURE_GATES_LIST = [
	RECORD_STORY,
	E2E_GREEN_TIP
];
